import { createRoutine } from 'redux-routines';
import {
  INIT, LOADING, SUCCESS, FAILURE,
} from '@constants/requestPhase';
import { storage } from '@utils';
import * as api from './api';

// < ----- ACTIONS ----- > //

// CATEGORY / SUBCATEGORY
const submitCategoriesOrderRoutine = createRoutine(
  'SUBMIT_CATEGORIES_ORDER',
);

const submitLoginRoutine = createRoutine(
  'SUBMIT_LOGIN',
);

const editCategoryRoutine = createRoutine(
  'EDIT_CATEGORY',
);

const deleteCategoryRoutine = createRoutine(
  'DELETE_CATEGORY',
);

const createSubcategoryRoutine = createRoutine(
  'CREATE_SUBCATEGORY',
);

const createCategoryRoutine = createRoutine(
  'CREATE_CATEGORY',
);

// ITEM
const editItemRoutine = createRoutine(
  'EDIT_ITEM',
);

const deleteItemRoutine = createRoutine(
  'DELETE_ITEM',
);

const createItemRoutine = createRoutine(
  'CREATE_ITEM',
);

// SIZE
const editSizeRoutine = createRoutine(
  'EDIT_SIZE',
);

const deleteSizeRoutine = createRoutine(
  'DELETE_SIZE',
);

const createSizeRoutine = createRoutine(
  'CREATE_SIZE',
);

// OPTION TO SIZE
const applyOptionToSizeRoutine = createRoutine(
  'APPLY_OPTION_TO_SIZE',
);

const detachOptionFromSizeRoutine = createRoutine(
  'DETACH_OPTION_FROM_SIZE',
);

// OPTION
const editOptionRoutine = createRoutine(
  'EDIT_OPTION',
);

const deleteOptionRoutine = createRoutine(
  'DELETE_OPTION',
);

const createOptionRoutine = createRoutine(
  'CREATE_OPTION',
);

// VALUE
const editValueRoutine = createRoutine(
  'EDIT_VALUE',
);

const deleteValueRoutine = createRoutine(
  'DELETE_VALUE',
);

const createValueRoutine = createRoutine(
  'CREATE_VALUE',
);

const applyAvailabilityToItemRoutine = createRoutine(
  'APPLY_AVAILABILITY_TO_ITEM',
);

const applyAvailabilityToCategoryRoutine = createRoutine(
  'APPLY_AVAILABILITY_TO_CATEGORY',
);

const applyAvailabilityToSpecialSizeRoutine = createRoutine(
  'APPLY_AVAILABILITY_TO_SPECIAL_SIZE',
);

const applyAvailabilityToSpecialCategoryRoutine = createRoutine(
  'APPLY_AVAILABILITY_TO_SPECIAL_CATEGORY',
);

const detachAvailabilityFromItemRoutine = createRoutine(
  'DETACH_AVAILABILITY_FROM_ITEM',
);

const detachAvailabilityFromCategoryRoutine = createRoutine(
  'DETACH_AVAILABILITY_FROM_CATEGORY',
);

const deleteAvailabilityRoutine = createRoutine(
  'DELETE_AVAILABILITY',
);

const editAvailabilityRoutine = createRoutine(
  'EDIT_AVAILABILITY',
);

const createAvailabilityForItemRoutine = createRoutine(
  'CREATE_AVAILABILITY_FOR_ITEM',
);

const createAvailabilityForCategoryRoutine = createRoutine(
  'CREATE_AVAILABILITY_FOR_CATEGORY',
);

const createAvailabilityForSpecialSizeRoutine = createRoutine(
  'CREATE_AVAILABILITY_FOR_SPECIAL_SIZE',
);

const createAvailabilityForSpecialCategoryRoutine = createRoutine(
  'CREATE_AVAILABILITY_FOR_SPECIAL_CATEGORY',
);

// SPECIALS

const createSpecialCategoryRoutine = createRoutine(
  'CREATE_SPECIAL_CATEGORY',
);

const editSpecialCategoryRoutine = createRoutine(
  'EDIT_SPECIAL_CATEGORY',
);

const createSpecialSizeRoutine = createRoutine(
  'CREATE_SPECIAL_SIZE',
);

const editSpecialSizeRoutine = createRoutine(
  'EDIT_SPECIAL_SIZE',
);

const deleteSpecialCategoryRoutine = createRoutine(
  'DELETE_SPECIAL_CATEGORY',
);

const deleteSpecialSizeRoutine = createRoutine(
  'DELETE_SPECIAL_SIZE',
);

const detachAvailabilityFromSpecialCategoryRoutine = createRoutine(
  'DETACH_AVAILABILITY_FROM_SPECIAL_CATEGORY',
);

const detachAvailabilityFromSpecialSizeRoutine = createRoutine(
  'DETACH_AVAILABILITY_FROM_SPECIAL_SIZE',
);

// < ----- ACTION CREATORS ----- > //

export const submitLogin = data => async dispatch => {
  try {
    dispatch(submitLoginRoutine.request());

    const response = await api.submitLogin(data);

    if (response.data.token) {
      storage.setToken(response.data.token);
    }

    return dispatch(submitLoginRoutine.success(response.data.menu));
  } catch (error) {
    return dispatch(submitLoginRoutine.failure(error.response));
  } finally {
    dispatch(submitLoginRoutine.fulfill());
  }
};

const createCommonThunk = (routine, request) => data => async dispatch => {
  try {
    dispatch(routine.request());

    const response = await request(data);

    return dispatch(routine.success(response.data));
  } catch (error) {
    return dispatch(routine.failure(error.response));
  } finally {
    dispatch(routine.fulfill());
  }
};

// CATEGORY

export const submitCategoriesOrder = createCommonThunk(submitCategoriesOrderRoutine, api.submitCategoriesOrder);

export const createSubcategory = createCommonThunk(createSubcategoryRoutine, api.createSubcategory);

export const createCategory = createCommonThunk(createCategoryRoutine, api.createCategory);

export const editCategory = createCommonThunk(editCategoryRoutine, api.editCategory);

export const deleteCategory = createCommonThunk(deleteCategoryRoutine, api.deleteCategory);

// ITEM
export const createItem = createCommonThunk(createItemRoutine, api.createItem);

export const editItem = createCommonThunk(editItemRoutine, api.editItem);

export const deleteItem = createCommonThunk(deleteItemRoutine, api.deleteItem);

// SIZE
export const createSize = createCommonThunk(createSizeRoutine, api.createSize);

export const editSize = createCommonThunk(editSizeRoutine, api.editSize);

export const deleteSize = createCommonThunk(deleteSizeRoutine, api.deleteSize);

// OPTION TO SIZE
export const applyOptionToSize = createCommonThunk(applyOptionToSizeRoutine, api.applyOptionToSize);

export const detachOptionFromSize = createCommonThunk(detachOptionFromSizeRoutine, api.detachOptionFromSize);

// OPTION
export const createOption = createCommonThunk(createOptionRoutine, api.createOption);

export const editOption = createCommonThunk(editOptionRoutine, api.editOption);

export const deleteOption = createCommonThunk(deleteOptionRoutine, api.deleteOption);

// VALUE
export const createValue = createCommonThunk(createValueRoutine, api.createValue);

export const editValue = createCommonThunk(editValueRoutine, api.editValue);

export const deleteValue = createCommonThunk(deleteValueRoutine, api.deleteValue);

// AVAILABILITY
export const applyAvailabilityToCategory = createCommonThunk(applyAvailabilityToCategoryRoutine,
  api.applyAvailabilityToCategory);

export const applyAvailabilityToItem = createCommonThunk(applyAvailabilityToItemRoutine, api.applyAvailabilityToItem);

export const applyAvailabilityToSpecialCategory = createCommonThunk(applyAvailabilityToSpecialCategoryRoutine,
  api.applyAvailabilityToSpecialCategory);

export const applyAvailabilityToSpecialSize = createCommonThunk(applyAvailabilityToSpecialSizeRoutine,
  api.applyAvailabilityToSpecialSize);

export const detachAvailabilityFromCategory = createCommonThunk(detachAvailabilityFromCategoryRoutine,
  api.detachAvailabilityFromCategory);

export const detachAvailabilityFromItem = createCommonThunk(detachAvailabilityFromItemRoutine,
  api.detachAvailabilityFromItem);

export const deleteAvailability = createCommonThunk(deleteAvailabilityRoutine, api.deleteAvailability);

export const editAvailability = createCommonThunk(editAvailabilityRoutine, api.editAvailability);

export const createAvailabilityForItem = createCommonThunk(createAvailabilityForItemRoutine,
  api.createAvailabilityForItem);

export const createAvailabilityForCategory = createCommonThunk(createAvailabilityForCategoryRoutine,
  api.createAvailabilityForCategory);

export const createAvailabilityForSpecialSize = createCommonThunk(createAvailabilityForSpecialSizeRoutine,
  api.createAvailabilityForSpecialSize);

export const createAvailabilityForSpecialCategory = createCommonThunk(createAvailabilityForSpecialCategoryRoutine,
  api.createAvailabilityForSpecialCategory);

// SPECIALS

export const createSpecialCategory = createCommonThunk(createSpecialCategoryRoutine,
  api.createSpecialCategory);

export const editSpecialCategory = createCommonThunk(editSpecialCategoryRoutine,
  api.editSpecialCategory);

export const createSpecialSize = createCommonThunk(createSpecialSizeRoutine,
  api.createSpecialSize);

export const editSpecialSize = createCommonThunk(editSpecialSizeRoutine,
  api.editSpecialSize);

export const deleteSpecialCategory = createCommonThunk(deleteSpecialCategoryRoutine, api.deleteSpecialCategory);

export const deleteSpecialSize = createCommonThunk(deleteSpecialSizeRoutine, api.deleteSpecialSize);

export const detachAvailabilityFromSpecialCategory = createCommonThunk(detachAvailabilityFromSpecialCategoryRoutine,
  api.detachAvailabilityFromSpecialCategory);

export const detachAvailabilityFromSpecialSize = createCommonThunk(detachAvailabilityFromSpecialSizeRoutine,
  api.detachAvailabilityFromSpecialSize);

// < ----- STATE ----- > //
export const menuStorePersistWhitelist = [
  'categories', 'options', 'optionValues', 'subcategories',
  'sizes', 'items', 'availabilities', 'specialsCategory', 'specialsSize',
];

const initialState = {
  categories: {
    byId: {},
    sortedIds: [],
  },
  options: {},
  optionValues: {},
  subcategories: {},
  sizes: {},
  items: {},
  availabilities: {},
  specialsCategory: {},
  specialsSize: {},

  submitLoginPhase: INIT,
  submitLoginError: null,

  // CATEGORY / SUBCATEGORY
  editCategoryPhase: INIT,
  editCategoryError: null,

  deleteCategoryPhase: INIT,
  deleteCategoryError: null,

  createCategoryPhase: INIT,
  createCategoryError: null,

  createSubcategoryPhase: INIT,
  createSubcategoryError: null,

  submitCategoriesOrderPhase: INIT,
  submitCategoriesOrderError: null,

  // ITEM
  editItemPhase: INIT,
  editItemError: null,

  deleteItemPhase: INIT,
  deleteItemError: null,

  createItemPhase: INIT,
  createItemError: null,

  // SIZE
  editSizePhase: INIT,
  editSizeError: null,

  deleteSizePhase: INIT,
  deleteSizeError: null,

  createSizePhase: INIT,
  createSizeError: null,

  // OPTION TO SIZE
  applyOptionToSizePhase: INIT,
  applyOptionToSizeError: null,

  detachOptionFromSizePhase: INIT,
  detachOptionFromSizeError: null,

  // OPTION
  editOptionPhase: INIT,
  editOptionError: null,

  deleteOptionPhase: INIT,
  deleteOptionError: null,

  createOptionPhase: INIT,
  createOptionError: null,

  // AVAILABILITY
  applyAvailabilityToCategoryError: null,
  applyAvailabilityToCategoryPhase: INIT,

  applyAvailabilityToItemError: null,
  applyAvailabilityToItemPhase: INIT,

  applyAvailabilityToSpecialCategoryError: null,
  applyAvailabilityToSpecialCategoryPhase: INIT,

  applyAvailabilityToSpecialSizeError: null,
  applyAvailabilityToSpecialSizePhase: INIT,

  detachAvailabilityFromCategoryError: null,
  detachAvailabilityFromCategoryPhase: INIT,

  detachAvailabilityFromItemError: null,
  detachAvailabilityFromItemPhase: INIT,

  deleteAvailabilityError: null,
  deleteAvailabilityPhase: INIT,

  editAvailabilityError: null,
  editAvailabilityPhase: INIT,

  createAvailabilityForItemError: null,
  createAvailabilityForCategoryPhase: INIT,

  createAvailabilityForSpecialSizeError: null,
  createAvailabilityForSpecialCategoryPhase: INIT,

  // SPECIALS
  editSpecialCategoryError: null,
  editSpecialCategoryPhase: INIT,

  createSpecialCategoryError: null,
  createSpecialCategoryPhase: INIT,

  editSpecialSizeError: null,
  editSpecialSizePhase: INIT,

  createSpecialSizeError: null,
  createSpecialSizePhase: INIT,

  deleteSpecialSizeError: null,
  deleteSpecialSizePhase: INIT,

  deleteSpecialCategoryError: null,
  deleteSpecialCategoryPhase: INIT,

  detachAvailabilityFromSpecialCategoryError: null,
  detachAvailabilityFromSpecialCategoryPhase: INIT,

  detachAvailabilityFromSpecialSizeError: null,
  detachAvailabilityFromSpecialSizePhase: INIT,
};

// < ----- STORE REDUCER ----- > //
const store = (state = initialState, { type, payload }) => {
  switch (type) {
    // CREATE CATEGORY
    case createCategoryRoutine.REQUEST:
      return {
        ...state,
        createCategoryPhase: LOADING,
      };
    case createCategoryRoutine.SUCCESS:
      return {
        ...state,
        createCategoryPhase: SUCCESS,
        categories: {
          ...state.categories,
          byId: {
            ...state.categories.byId,
            ...payload,
          },
          sortedIds: [
            ...state.categories.sortedIds,
            parseInt(...Object.keys(payload), 10),
          ],
        },
      };
    case createCategoryRoutine.FAILURE:
      return {
        ...state,
        createCategoryPhase: FAILURE,
        createCategoryError: payload,
      };
    case createCategoryRoutine.FULFILL:
      return {
        ...state,
        createCategoryPhase: initialState.createCategoryPhase,
        createCategoryError: initialState.createCategoryError,
      };
    // CREATE SUBCATEGORY
    case createSubcategoryRoutine.REQUEST:
      return {
        ...state,
        createSubcategoryPhase: LOADING,
      };
    case createSubcategoryRoutine.SUCCESS:
      return {
        ...state,
        categories: {
          ...state.categories,
          byId: {
            ...state.categories.byId,
            [payload.categoryId]: {
              ...state.categories.byId[payload.categoryId],
              subcategoryIds: [
                ...state.categories.byId[payload.categoryId].subcategoryIds,
                payload.subcategoryId,
              ],
            },
          },
        },
        subcategories: {
          ...state.subcategories,
          ...payload.createdSubcategory,
        },
        createSubcategoryPhase: SUCCESS,
      };
    case createSubcategoryRoutine.FAILURE:
      return {
        ...state,
        createSubcategoryPhase: FAILURE,
        createSubcategoryError: payload,
      };
    case createSubcategoryRoutine.FULFILL:
      return {
        ...state,
        createSubcategoryPhase: initialState.createSubcategoryPhase,
        createSubcategoryError: initialState.createSubcategoryError,
      };
    // DELETE CATEGORY
    case deleteCategoryRoutine.REQUEST:
      return {
        ...state,
        deleteCategoryPhase: LOADING,
      };
    case deleteCategoryRoutine.SUCCESS:
      return {
        ...state,
        deleteCategoryPhase: SUCCESS,
        categories: {
          ...state.categories,
          ...payload.categories,
        },
        subcategories: {
          ...state.subcategories,
          ...payload.subcategories,
        },
        items: {
          ...state.items,
          ...payload.items,
        },
      };
    case deleteCategoryRoutine.FAILURE:
      return {
        ...state,
        deleteCategoryPhase: FAILURE,
        deleteCategoryError: payload,
      };
    case deleteCategoryRoutine.FULFILL:
      return {
        ...state,
        deleteCategoryPhase: initialState.deleteCategoryPhase,
        deleteCategoryError: initialState.deleteCategoryError,
      };
    // EDIT CATEGORY
    case editCategoryRoutine.REQUEST:
      return {
        ...state,
        editCategoryPhase: LOADING,
      };
    case editCategoryRoutine.SUCCESS:
      return {
        ...state,
        editCategoryPhase: SUCCESS,
        categories: {
          ...state.categories,
          ...payload.categories,
        },
        subcategories: {
          ...state.subcategories,
          ...payload.subcategories,
        },
        items: {
          ...state.items,
          ...payload.items,
        },
      };
    case editCategoryRoutine.FAILURE:
      return {
        ...state,
        editCategoryPhase: FAILURE,
        editCategoryError: payload,
      };
    case editCategoryRoutine.FULFILL:
      return {
        ...state,
        editCategoryPhase: initialState.editCategoryPhase,
        editCategoryError: initialState.editCategoryError,
      };
    // SUBMIT CATEGORIES ORDER
    case submitCategoriesOrderRoutine.REQUEST:
      return {
        ...state,
        submitCategoriesOrderPhase: LOADING,
      };
    case submitCategoriesOrderRoutine.SUCCESS:
      return {
        ...state,
        categories: {
          ...state.categories,
          sortedIds: payload.sortedIds,
        },
        submitCategoriesOrderPhase: SUCCESS,
      };
    case submitCategoriesOrderRoutine.FAILURE:
      return {
        ...state,
        submitCategoriesOrderPhase: FAILURE,
        submitCategoriesOrderError: payload,
      };
    case submitCategoriesOrderRoutine.FULFILL:
      return {
        ...state,
        submitCategoriesOrderPhase: initialState.submitCategoriesOrderPhase,
        submitCategoriesOrderError: initialState.submitCategoriesOrderError,
      };
    // SUBMIT LOGIN
    case submitLoginRoutine.REQUEST:
      return {
        ...state,
        submitLoginPhase: LOADING,
      };
    case submitLoginRoutine.SUCCESS:
      return {
        ...state,
        submitLoginPhase: SUCCESS,
        categories: {
          ...state.categories,
          ...payload.categories,
        },
        subcategories: {
          ...state.subcategories,
          ...payload.subcategories,
        },
        items: {
          ...state.items,
          ...payload.items,
        },
        sizes: {
          ...state.sizes,
          ...payload.sizes,
        },
        options: {
          ...state.options,
          ...payload.options,
        },
        optionValues: {
          ...state.optionValues,
          ...payload.optionValues,
        },
        availabilities: {
          ...state.availabilities,
          ...payload.availabilities,
        },
        specialsCategory: {
          ...state.specialsCategory,
          ...payload.specialsCategory,
        },
        specialsSize: {
          ...state.specialsSize,
          ...payload.specialsSize,
        },
      };
    case submitLoginRoutine.FAILURE:
      return {
        ...state,
        submitLoginPhase: FAILURE,
        submitLoginError: payload,
      };
    case submitLoginRoutine.FULFILL:
      return {
        ...state,
        submitLoginPhase: initialState.submitLoginPhase,
        submitLoginError: initialState.submitLoginError,
      };

    // CREATE ITEM
    case createItemRoutine.REQUEST:
      return {
        ...state,
        createItemPhase: LOADING,
      };
    case createItemRoutine.SUCCESS:
      return {
        ...state,
        createItemPhase: SUCCESS,
        items: payload.items,
        categories: payload.categories,
        sizes: payload.sizes,
      };
    case createItemRoutine.FAILURE:
      return {
        ...state,
        createItemPhase: FAILURE,
        createItemError: payload,
      };
    case createItemRoutine.FULFILL:
      return {
        ...state,
        createItemPhase: initialState.createItemPhase,
        createItemError: initialState.createItemError,
      };

    // EDIT ITEM
    case editItemRoutine.REQUEST:
      return {
        ...state,
        editItemPhase: LOADING,
      };
    case editItemRoutine.SUCCESS:
      return {
        ...state,
        editItemPhase: SUCCESS,
        items: payload.items,
      };
    case editItemRoutine.FAILURE:
      return {
        ...state,
        editItemPhase: FAILURE,
        editItemError: payload,
      };
    case editItemRoutine.FULFILL:
      return {
        ...state,
        editItemPhase: initialState.editItemPhase,
        editItemError: initialState.editItemError,
      };

    // DELETE ITEM
    case deleteItemRoutine.REQUEST:
      return {
        ...state,
        deleteItemPhase: LOADING,
      };
    case deleteItemRoutine.SUCCESS:
      return {
        ...state,
        items: payload.items,
        categories: payload.categories,
        deleteItemPhase: SUCCESS,
      };
    case deleteItemRoutine.FAILURE:
      return {
        ...state,
        deleteItemPhase: FAILURE,
        deleteItemError: payload,
      };
    case deleteItemRoutine.FULFILL:
      return {
        ...state,
        deleteItemPhase: initialState.deleteItemPhase,
        deleteItemError: initialState.deleteItemError,
      };

    // CREATE SIZE
    case createSizeRoutine.REQUEST:
      return {
        ...state,
        createSizePhase: LOADING,
      };
    case createSizeRoutine.SUCCESS:
      return {
        ...state,
        createSizePhase: SUCCESS,
        items: payload.items,
        sizes: payload.sizes,
      };
    case createSizeRoutine.FAILURE:
      return {
        ...state,
        createSizePhase: FAILURE,
        createSizeError: payload,
      };
    case createSizeRoutine.FULFILL:
      return {
        ...state,
        createSizePhase: initialState.createSizePhase,
        createSizeError: initialState.createSizeError,
      };

    // EDIT SUZE
    case editSizeRoutine.REQUEST:
      return {
        ...state,
        editSizePhase: LOADING,
      };
    case editSizeRoutine.SUCCESS:
      return {
        ...state,
        editSizePhase: SUCCESS,
        sizes: payload.sizes,
      };
    case editSizeRoutine.FAILURE:
      return {
        ...state,
        editSizePhase: FAILURE,
        editSizeError: payload,
      };
    case editSizeRoutine.FULFILL:
      return {
        ...state,
        editSizePhase: initialState.editSizePhase,
        editSizeError: initialState.editSizeError,
      };

    // DELETE SIZE
    case deleteSizeRoutine.REQUEST:
      return {
        ...state,
        deleteSizePhase: LOADING,
      };
    case deleteSizeRoutine.SUCCESS:
      return {
        ...state,
        sizes: payload.sizes,
        items: payload.items,
        deleteSizePhase: SUCCESS,
      };
    case deleteSizeRoutine.FAILURE:
      return {
        ...state,
        deleteSizePhase: FAILURE,
        deleteSizeError: payload,
      };
    case deleteSizeRoutine.FULFILL:
      return {
        ...state,
        deleteSizePhase: initialState.deleteSizePhase,
        deleteSizeError: initialState.deleteSizeError,
      };

    // APPLY OPTION TO SIZE
    case applyOptionToSizeRoutine.REQUEST:
      return {
        ...state,
        applyOptionToSizePhase: LOADING,
      };
    case applyOptionToSizeRoutine.SUCCESS:
      return {
        ...state,
        sizes: payload.sizes,
        applyOptionToSizePhase: SUCCESS,
      };
    case applyOptionToSizeRoutine.FAILURE:
      return {
        ...state,
        applyOptionToSizePhase: FAILURE,
        applyOptionToSizeError: payload,
      };
    case applyOptionToSizeRoutine.FULFILL:
      return {
        ...state,
        applyOptionToSizePhase: initialState.applyOptionToSizePhase,
        applyOptionToSizeError: initialState.applyOptionToSizeError,
      };

    // DETACH OPTION FROM SIZE
    case detachOptionFromSizeRoutine.REQUEST:
      return {
        ...state,
        detachOptionFromSizePhase: LOADING,
      };
    case detachOptionFromSizeRoutine.SUCCESS:
      return {
        ...state,
        sizes: payload.sizes,
        detachOptionFromSizePhase: SUCCESS,
      };
    case detachOptionFromSizeRoutine.FAILURE:
      return {
        ...state,
        detachOptionFromSizePhase: FAILURE,
        detachOptionFromSizeError: payload,
      };
    case detachOptionFromSizeRoutine.FULFILL:
      return {
        ...state,
        detachOptionFromSizePhase: initialState.detachOptionFromSizePhase,
        detachOptionFromSizeError: initialState.detachOptionFromSizeError,
      };

      // CREATE OPTION
    case createOptionRoutine.REQUEST:
      return {
        ...state,
        createOptionPhase: LOADING,
      };
    case createOptionRoutine.SUCCESS:
      return {
        ...state,
        createOptionPhase: SUCCESS,
        sizes: payload.sizes,
        options: payload.options,
      };
    case createOptionRoutine.FAILURE:
      return {
        ...state,
        createOptionPhase: FAILURE,
        createOptionError: payload,
      };
    case createOptionRoutine.FULFILL:
      return {
        ...state,
        createOptionPhase: initialState.createOptionPhase,
        createOptionError: initialState.createOptionError,
      };

    // EDIT OPTION
    case editOptionRoutine.REQUEST:
      return {
        ...state,
        editOptionPhase: LOADING,
      };
    case editOptionRoutine.SUCCESS:
      return {
        ...state,
        editOptionPhase: SUCCESS,
        options: payload.options,
      };
    case editOptionRoutine.FAILURE:
      return {
        ...state,
        editOptionPhase: FAILURE,
        editOptionError: payload,
      };
    case editOptionRoutine.FULFILL:
      return {
        ...state,
        editOptionPhase: initialState.editOptionPhase,
        editOptionError: initialState.editOptionError,
      };

    // DELETE OPTION
    case deleteOptionRoutine.REQUEST:
      return {
        ...state,
        deleteOptionPhase: LOADING,
      };
    case deleteOptionRoutine.SUCCESS:
      return {
        ...state,
        sizes: payload.sizes,
        options: payload.options,
        optionValues: payload.optionValues,
        deleteOptionPhase: SUCCESS,
      };
    case deleteOptionRoutine.FAILURE:
      return {
        ...state,
        deleteOptionPhase: FAILURE,
        deleteOptionError: payload,
      };
    case deleteOptionRoutine.FULFILL:
      return {
        ...state,
        deleteOptionPhase: initialState.deleteOptionPhase,
        deleteOptionError: initialState.deleteOptionError,
      };

    // CREATE VALUE
    case createValueRoutine.REQUEST:
      return {
        ...state,
        createValuePhase: LOADING,
      };
    case createValueRoutine.SUCCESS:
      return {
        ...state,
        createValuePhase: SUCCESS,
        options: payload.options,
        optionValues: payload.optionValues,
      };
    case createValueRoutine.FAILURE:
      return {
        ...state,
        createValuePhase: FAILURE,
        createValueError: payload,
      };
    case createValueRoutine.FULFILL:
      return {
        ...state,
        createValuePhase: initialState.createValuePhase,
        createValueError: initialState.createValueError,
      };

    // EDIT VALUE
    case editValueRoutine.REQUEST:
      return {
        ...state,
        editValuePhase: LOADING,
      };
    case editValueRoutine.SUCCESS:
      return {
        ...state,
        editValuePhase: SUCCESS,
        optionValues: payload.optionValues,
      };
    case editValueRoutine.FAILURE:
      return {
        ...state,
        editValuePhase: FAILURE,
        editValueError: payload,
      };
    case editValueRoutine.FULFILL:
      return {
        ...state,
        editValuePhase: initialState.editValuePhase,
        editValueError: initialState.editValueError,
      };

    // DELETE VALUE
    case deleteValueRoutine.REQUEST:
      return {
        ...state,
        deleteValuePhase: LOADING,
      };
    case deleteValueRoutine.SUCCESS:
      return {
        ...state,
        options: payload.options,
        optionValues: payload.optionValues,
        deleteValuePhase: SUCCESS,
      };
    case deleteValueRoutine.FAILURE:
      return {
        ...state,
        deleteValuePhase: FAILURE,
        deleteValueError: payload,
      };
    case deleteValueRoutine.FULFILL:
      return {
        ...state,
        deleteValuePhase: initialState.deleteValuePhase,
        deleteValueError: initialState.deleteValueError,
      };

    // APPLY AVAILABILITY TO ITEM
    case applyAvailabilityToItemRoutine.REQUEST:
      return {
        ...state,
        applyAvailabilityToItemPhase: LOADING,
      };
    case applyAvailabilityToItemRoutine.SUCCESS:
      return {
        ...state,
        items: payload.items,
        applyAvailabilityToItemPhase: SUCCESS,
      };
    case applyAvailabilityToItemRoutine.FAILURE:
      return {
        ...state,
        applyAvailabilityToItemPhase: FAILURE,
        applyAvailabilityToItemError: payload,
      };
    case applyAvailabilityToItemRoutine.FULFILL:
      return {
        ...state,
        applyAvailabilityToItemPhase: initialState.applyAvailabilityToItemPhase,
        applyAvailabilityToItemError: initialState.applyAvailabilityToItemError,
      };

    // APPLY AVAILABILITY TO CATEGORY
    case applyAvailabilityToCategoryRoutine.REQUEST:
      return {
        ...state,
        applyAvailabilityToCategoryPhase: LOADING,
      };
    case applyAvailabilityToCategoryRoutine.SUCCESS:
      return {
        ...state,
        categories: payload.categories,
        subcategories: payload.subcategories,
        applyAvailabilityToCategoryPhase: SUCCESS,
      };
    case applyAvailabilityToCategoryRoutine.FAILURE:
      return {
        ...state,
        applyAvailabilityToCategoryPhase: FAILURE,
        applyAvailabilityToCategoryError: payload,
      };
    case applyAvailabilityToCategoryRoutine.FULFILL:
      return {
        ...state,
        applyAvailabilityToCategoryPhase: initialState.applyAvailabilityToCategoryPhase,
        applyAvailabilityToCategoryError: initialState.applyAvailabilityToCategoryError,
      };

    // APPLY AVAILABILITY TO SPECIAL SIZE
    case applyAvailabilityToSpecialSizeRoutine.REQUEST:
      return {
        ...state,
        applyAvailabilityToSpecialSizePhase: LOADING,
      };
    case applyAvailabilityToSpecialSizeRoutine.SUCCESS:
      return {
        ...state,
        specialsSize: payload.specialsSize,
        applyAvailabilityToSpecialSizePhase: SUCCESS,
      };
    case applyAvailabilityToSpecialSizeRoutine.FAILURE:
      return {
        ...state,
        applyAvailabilityToSpecialSizePhase: FAILURE,
        applyAvailabilityToSpecialSizeError: payload,
      };
    case applyAvailabilityToSpecialSizeRoutine.FULFILL:
      return {
        ...state,
        applyAvailabilityToSpecialSizePhase: initialState.applyAvailabilityToSpecialSizePhase,
        applyAvailabilityToSpecialSizeError: initialState.applyAvailabilityToSpecialSizeError,
      };

    // APPLY AVAILABILITY TO SPECIAL CATEGORY
    case applyAvailabilityToSpecialCategoryRoutine.REQUEST:
      return {
        ...state,
        applyAvailabilityToSpecialCategoryPhase: LOADING,
      };
    case applyAvailabilityToSpecialCategoryRoutine.SUCCESS:
      return {
        ...state,
        specialsCategory: payload.specialsCategory,
        applyAvailabilityToSpecialCategoryPhase: SUCCESS,
      };
    case applyAvailabilityToSpecialCategoryRoutine.FAILURE:
      return {
        ...state,
        applyAvailabilityToSpecialCategoryPhase: FAILURE,
        applyAvailabilityToSpecialCategoryError: payload,
      };
    case applyAvailabilityToSpecialCategoryRoutine.FULFILL:
      return {
        ...state,
        applyAvailabilityToSpecialCategoryPhase: initialState.applyAvailabilityToSpecialCategoryPhase,
        applyAvailabilityToSpecialCategoryError: initialState.applyAvailabilityToSpecialCategoryError,
      };

      // DETACH AVAILABILITY FROM ITEM
    case detachAvailabilityFromItemRoutine.REQUEST:
      return {
        ...state,
        detachAvailabilityFromItemPhase: LOADING,
      };
    case detachAvailabilityFromItemRoutine.SUCCESS:
      return {
        ...state,
        items: payload.items,
        detachAvailabilityFromItemPhase: SUCCESS,
      };
    case detachAvailabilityFromItemRoutine.FAILURE:
      return {
        ...state,
        detachAvailabilityFromItemPhase: FAILURE,
        detachAvailabilityFromItemError: payload,
      };
    case detachAvailabilityFromItemRoutine.FULFILL:
      return {
        ...state,
        detachAvailabilityFromItemPhase: initialState.detachAvailabilityFromItemPhase,
        detachAvailabilityFromItemError: initialState.detachAvailabilityFromItemError,
      };

    // DETACH AVAILABILITY FROM CATEGORY
    case detachAvailabilityFromCategoryRoutine.REQUEST:
      return {
        ...state,
        detachAvailabilityFromCategoryPhase: LOADING,
      };
    case detachAvailabilityFromCategoryRoutine.SUCCESS:
      return {
        ...state,
        categories: payload.categories,
        subcategories: payload.subcategories,
        detachAvailabilityFromCategoryPhase: SUCCESS,
      };
    case detachAvailabilityFromCategoryRoutine.FAILURE:
      return {
        ...state,
        detachAvailabilityFromCategoryPhase: FAILURE,
        detachAvailabilityFromCategoryError: payload,
      };
    case detachAvailabilityFromCategoryRoutine.FULFILL:
      return {
        ...state,
        detachAvailabilityFromCategoryPhase: initialState.detachAvailabilityFromCategoryPhase,
        detachAvailabilityFromCategoryError: initialState.detachAvailabilityFromCategoryError,
      };

    // DELETE AVAILABILITY
    case deleteAvailabilityRoutine.REQUEST:
      return {
        ...state,
        deleteAvailabilityPhase: LOADING,
      };
    case deleteAvailabilityRoutine.SUCCESS:
      return {
        ...state,
        categories: payload.categories,
        subcategories: payload.subcategories,
        items: payload.items,
        specialsCategory: payload.specialsCategory,
        specialsSize: payload.specialsSize,
        availabilities: payload.availabilities,
        deleteAvailabilityPhase: SUCCESS,
      };
    case deleteAvailabilityRoutine.FAILURE:
      return {
        ...state,
        deleteAvailabilityPhase: FAILURE,
        deleteAvailabilityError: payload,
      };
    case deleteAvailabilityRoutine.FULFILL:
      return {
        ...state,
        deleteAvailabilityPhase: initialState.deleteAvailabilityPhase,
        deleteAvailabilityError: initialState.deleteAvailabilityError,
      };

      // EDIT AVAILABILITY
    case editAvailabilityRoutine.REQUEST:
      return {
        ...state,
        editAvailabilityPhase: LOADING,
      };
    case editAvailabilityRoutine.SUCCESS:
      return {
        ...state,
        availabilities: payload.availabilities,
        editAvailabilityPhase: SUCCESS,
      };
    case editAvailabilityRoutine.FAILURE:
      return {
        ...state,
        editAvailabilityPhase: FAILURE,
        editAvailabilityError: payload,
      };
    case editAvailabilityRoutine.FULFILL:
      return {
        ...state,
        editAvailabilityPhase: initialState.editAvailabilityPhase,
        editAvailabilityError: initialState.editAvailabilityError,
      };

      // CREATE AVAILABILITY FOR ITEM
    case createAvailabilityForItemRoutine.REQUEST:
      return {
        ...state,
        createAvailabilityForItemPhase: LOADING,
      };
    case createAvailabilityForItemRoutine.SUCCESS:
      return {
        ...state,
        items: payload.items,
        availabilities: payload.availabilities,
        createAvailabilityForItemPhase: SUCCESS,
      };
    case createAvailabilityForItemRoutine.FAILURE:
      return {
        ...state,
        createAvailabilityForItemPhase: FAILURE,
        createAvailabilityForItemError: payload,
      };
    case createAvailabilityForItemRoutine.FULFILL:
      return {
        ...state,
        createAvailabilityForItemPhase: initialState.createAvailabilityForItemPhase,
        createAvailabilityForItemError: initialState.createAvailabilityForItemError,
      };

      // CREATE AVAILABILITY FOR CATEGORY
    case createAvailabilityForCategoryRoutine.REQUEST:
      return {
        ...state,
        createAvailabilityForCategoryPhase: LOADING,
      };
    case createAvailabilityForCategoryRoutine.SUCCESS:
      return {
        ...state,
        categories: payload.categories,
        subcategories: payload.subcategories,
        availabilities: payload.availabilities,
        createAvailabilityForCategoryPhase: SUCCESS,
      };
    case createAvailabilityForCategoryRoutine.FAILURE:
      return {
        ...state,
        createAvailabilityForCategoryPhase: FAILURE,
        createAvailabilityForCategoryError: payload,
      };
    case createAvailabilityForCategoryRoutine.FULFILL:
      return {
        ...state,
        createAvailabilityForCategoryPhase: initialState.createAvailabilityForCategoryPhase,
        createAvailabilityForCategoryError: initialState.createAvailabilityForCategoryError,
      };

    // CREATE AVAILABILITY FOR SPECIAL CATEGORY
    case createAvailabilityForSpecialCategoryRoutine.REQUEST:
      return {
        ...state,
        createAvailabilityForSpecialCategoryPhase: LOADING,
      };
    case createAvailabilityForSpecialCategoryRoutine.SUCCESS:
      return {
        ...state,
        specialsCategory: payload.specialsCategory,
        availabilities: payload.availabilities,
        createAvailabilityForSpecialCategoryPhase: SUCCESS,
      };
    case createAvailabilityForSpecialCategoryRoutine.FAILURE:
      return {
        ...state,
        createAvailabilityForSpecialCategoryPhase: FAILURE,
        createAvailabilityForSpecialCategoryError: payload,
      };
    case createAvailabilityForSpecialCategoryRoutine.FULFILL:
      return {
        ...state,
        createAvailabilityForSpecialCategoryPhase: initialState.createAvailabilityForSpecialCategoryPhase,
        createAvailabilityForSpecialCategoryError: initialState.createAvailabilityForSpecialCategoryError,
      };

      // CREATE AVAILABILITY FOR SPECIAL SIZE
    case createAvailabilityForSpecialSizeRoutine.REQUEST:
      return {
        ...state,
        createAvailabilityForSpecialSizePhase: LOADING,
      };
    case createAvailabilityForSpecialSizeRoutine.SUCCESS:
      return {
        ...state,
        specialsSize: payload.specialsSize,
        availabilities: payload.availabilities,
        createAvailabilityForSpecialSizePhase: SUCCESS,
      };
    case createAvailabilityForSpecialSizeRoutine.FAILURE:
      return {
        ...state,
        createAvailabilityForSpecialSizePhase: FAILURE,
        createAvailabilityForSpecialSizeError: payload,
      };
    case createAvailabilityForSpecialSizeRoutine.FULFILL:
      return {
        ...state,
        createAvailabilityForSpecialSizePhase: initialState.createAvailabilityForSpecialSizePhase,
        createAvailabilityForSpecialSizeError: initialState.createAvailabilityForSpecialSizeError,
      };

    // CREATE SPECIAL CATEGORY
    case createSpecialCategoryRoutine.REQUEST:
      return {
        ...state,
        createSpecialCategoryPhase: LOADING,
      };
    case createSpecialCategoryRoutine.SUCCESS:
      return {
        ...state,
        categories: payload.categories,
        subcategories: payload.subcategories,
        sizes: payload.sizes,
        specialsCategory: payload.specialsCategory,
        createSpecialCategoryPhase: SUCCESS,
      };
    case createSpecialCategoryRoutine.FAILURE:
      return {
        ...state,
        createSpecialCategoryPhase: FAILURE,
        createSpecialCategoryError: payload,
      };
    case createSpecialCategoryRoutine.FULFILL:
      return {
        ...state,
        createSpecialCategoryPhase: initialState.createSpecialCategoryPhase,
        createSpecialCategoryError: initialState.createSpecialCategoryError,
      };

    // EDIT SPECIAL CATEGORY
    case editSpecialCategoryRoutine.REQUEST:
      return {
        ...state,
        editSpecialCategoryPhase: LOADING,
      };
    case editSpecialCategoryRoutine.SUCCESS:
      return {
        ...state,
        specialsCategory: payload.specialsCategory,
        sizes: payload.sizes,
        editSpecialCategoryPhase: SUCCESS,
      };
    case editSpecialCategoryRoutine.FAILURE:
      return {
        ...state,
        editSpecialCategoryPhase: FAILURE,
        editSpecialCategoryError: payload,
      };
    case editSpecialCategoryRoutine.FULFILL:
      return {
        ...state,
        editSpecialCategoryPhase: initialState.editSpecialCategoryPhase,
        editSpecialCategoryError: initialState.editSpecialCategoryError,
      };

    // CREATE SPECIAL SIZE
    case createSpecialSizeRoutine.REQUEST:
      return {
        ...state,
        createSpecialSizePhase: LOADING,
      };
    case createSpecialSizeRoutine.SUCCESS:
      return {
        ...state,
        sizes: payload.sizes,
        specialsSize: payload.specialsSize,
        createSpecialSizePhase: SUCCESS,
      };
    case createSpecialSizeRoutine.FAILURE:
      return {
        ...state,
        createSpecialSizePhase: FAILURE,
        createSpecialSizeError: payload,
      };
    case createSpecialSizeRoutine.FULFILL:
      return {
        ...state,
        createSpecialSizePhase: initialState.createSpecialSizePhase,
        createSpecialSizeError: initialState.createSpecialSizeError,
      };

    // EDIT SPECIAL SIZE
    case editSpecialSizeRoutine.REQUEST:
      return {
        ...state,
        editSpecialSizePhase: LOADING,
      };
    case editSpecialSizeRoutine.SUCCESS:
      return {
        ...state,
        specialsSize: payload.specialsSize,
        sizes: payload.sizes,
        editSpecialSizePhase: SUCCESS,
      };
    case editSpecialSizeRoutine.FAILURE:
      return {
        ...state,
        editSpecialSizePhase: FAILURE,
        editSpecialSizeError: payload,
      };
    case editSpecialSizeRoutine.FULFILL:
      return {
        ...state,
        editSpecialSizePhase: initialState.editSpecialSizePhase,
        editSpecialSizeError: initialState.editSpecialSizeError,
      };

    // DELETE SPECIAL SIZE
    case deleteSpecialSizeRoutine.REQUEST:
      return {
        ...state,
        deleteSpecialSizePhase: LOADING,
      };
    case deleteSpecialSizeRoutine.SUCCESS:
      return {
        ...state,
        sizes: payload.sizes,
        specialsSize: payload.specialsSize,
        deleteSpecialSizePhase: SUCCESS,
      };
    case deleteSpecialSizeRoutine.FAILURE:
      return {
        ...state,
        deleteSpecialSizePhase: FAILURE,
        deleteSpecialSizeError: payload,
      };
    case deleteSpecialSizeRoutine.FULFILL:
      return {
        ...state,
        deleteSpecialSizePhase: initialState.deleteSpecialSizePhase,
        deleteSpecialSizeError: initialState.deleteSpecialSizeError,
      };

    // DELETE SPECIAL SIZE
    case deleteSpecialCategoryRoutine.REQUEST:
      return {
        ...state,
        deleteSpecialCategoryPhase: LOADING,
      };
    case deleteSpecialCategoryRoutine.SUCCESS:
      return {
        ...state,
        categories: payload.categories,
        subcategories: payload.subcategories,
        sizes: payload.sizes,
        specialsCategory: payload.specialsCategory,
        deleteSpecialCategoryPhase: SUCCESS,
      };
    case deleteSpecialCategoryRoutine.FAILURE:
      return {
        ...state,
        deleteSpecialCategoryPhase: FAILURE,
        deleteSpecialCategoryError: payload,
      };
    case deleteSpecialCategoryRoutine.FULFILL:
      return {
        ...state,
        deleteSpecialCategoryPhase: initialState.deleteSpecialCategoryPhase,
        deleteSpecialCategoryError: initialState.deleteSpecialCategoryError,
      };

    // DETACH AVAILABILITY FROM SPECIAL CATEGORY
    case detachAvailabilityFromSpecialCategoryRoutine.REQUEST:
      return {
        ...state,
        detachAvailabilityFromSpecialCategoryPhase: LOADING,
      };
    case detachAvailabilityFromSpecialCategoryRoutine.SUCCESS:
      return {
        ...state,
        specialsCategory: payload.specialsCategory,
        detachAvailabilityFromSpecialCategoryPhase: SUCCESS,
      };
    case detachAvailabilityFromSpecialCategoryRoutine.FAILURE:
      return {
        ...state,
        detachAvailabilityFromSpecialCategoryPhase: FAILURE,
        detachAvailabilityFromSpecialCategoryError: payload,
      };
    case detachAvailabilityFromSpecialCategoryRoutine.FULFILL:
      return {
        ...state,
        detachAvailabilityFromSpecialCategoryPhase: initialState.detachAvailabilityFromSpecialCategoryPhase,
        detachAvailabilityFromSpecialCategoryError: initialState.detachAvailabilityFromSpecialCategoryError,
      };

    // DETACH AVAILABILITY FROM SPECIAL CATEGORY
    case detachAvailabilityFromSpecialSizeRoutine.REQUEST:
      return {
        ...state,
        detachAvailabilityFromSpecialSizePhase: LOADING,
      };
    case detachAvailabilityFromSpecialSizeRoutine.SUCCESS:
      return {
        ...state,
        specialsSize: payload.specialsSize,
        detachAvailabilityFromSpecialSizePhase: SUCCESS,
      };
    case detachAvailabilityFromSpecialSizeRoutine.FAILURE:
      return {
        ...state,
        detachAvailabilityFromSpecialSizePhase: FAILURE,
        detachAvailabilityFromSpecialSizeError: payload,
      };
    case detachAvailabilityFromSpecialSizeRoutine.FULFILL:
      return {
        ...state,
        detachAvailabilityFromSpecialSizePhase: initialState.detachAvailabilityFromSpecialSizePhase,
        detachAvailabilityFromSpecialSizeError: initialState.detachAvailabilityFromSpecialSizeError,
      };
    default:
      return state;
  }
};

export default store;
